<template>
  <div class="yuncang" :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }">
    <div class="topNavBar">
      <van-icon name="arrow-left" class="backIcon" @click="goback()" />
      <van-search
        v-model="reqParameter.name"
        placeholder="请输入搜索关键词"
        @search="onRefresh()"
        @cancel="onClear()"
        @clear="onClear()"
      />
    </div>
    <div class="factor">
      <div class="leftFactor">
        <span
          v-for="(item, index) in orderByList"
          :key="index"
          @click="search(item.value)"
          :class="reqParameter.order_by == item.value ? 'current' : ''"
          >{{ item.label }}
          <img
            v-if="item.icon && reqParameter.order_by == 'inventory'"
            src="../../assets/yuncang/icon-05.png"
            alt=""
          />
          <img
            v-if="
              item.icon &&
              reqParameter.order_by == 'activity_min_price' &&
              reqParameter.sort == 'asc'
            "
            src="../../assets/yuncang/icon-01.png"
            alt=""
          />
          <img
            v-if="
              item.icon &&
              reqParameter.order_by == 'activity_min_price' &&
              reqParameter.sort == 'desc'
            "
            src="../../assets/yuncang/icon-02.png"
            alt=""
          />
        </span>
      </div>
      <div class="rightFactor" is-link @click="show = true">
        筛选
        <img src="../../assets/yuncang/icon-03.png" alt="" />
      </div>
    </div>
    <!-- 右侧弹出筛选条件 -->
    <van-popup
      v-model="show"
      position="right"
      :close-on-click-overlay="false"
      @click-overlay="
        show = false;
        onRefresh();
      "
      :style="{ height: '100%', width: '304px' }"
    >
      <div style="height: 100%" v-if="isVisible">
        <div class="typeMain">
          <div class="content">
            <div class="title" @click="more = !more">
              <h2>品牌</h2>
              <div class="selectBrand">
                <p>
                  <span v-for="(item, index) in selectedBrand" :key="index"
                    >{{ item
                    }}<i v-if="index + 1 != selectedBrand.length">，</i></span
                  >
                </p>
                <img
                  v-if="more"
                  src="../../assets/yuncang/icon-08.png"
                  alt=""
                />
                <img v-else src="../../assets/yuncang/icon-06.png" alt="" />
              </div>
            </div>
            <van-row
              gutter="5"
              class="brandUl"
              :style="{ height: more ? 'auto' : '185px' }"
            >
              <van-col
                span="8"
                class="item"
                v-for="(item, index) in brandList"
                :key="index"
                @click="checkBrand(item.id, item.ename)"
                ><p
                  :class="
                    reqParameter.brand_id.indexOf(item.id) != -1
                      ? 'current'
                      : ''
                  "
                >
                  {{ item.ename }}
                </p></van-col
              >
              <van-col
                span="8"
                class="item"
                @click="seeAllBrand()"
                v-if="brandList.length >= 23"
                ><p class="moreBtn">更多品牌</p></van-col
              >
            </van-row>
          </div>
          <div class="content">
            <div class="title">
              <h2>发货仓</h2>
              <!-- <img src="../../assets/yuncang/icon-02.png" alt="" /> -->
            </div>
            <van-row gutter="5">
              <van-col
                span="8"
                class="item"
                v-for="(item, index) in depositoryList"
                :key="index"
                @click="checkDepository(item)"
                ><p
                  :class="
                    reqParameter.warehouse.indexOf(item) != -1 ? 'current' : ''
                  "
                >
                  {{ item }}
                </p></van-col
              >
            </van-row>
          </div>
          <div class="content">
            <div class="title">
              <h2>价格区间</h2>
              <!-- <img src="../../assets/yuncang/icon-02.png" alt="" /> -->
            </div>
            <div class="priceRange">
              <input
                type="number"
                v-model="reqParameter.activity_price[0]"
                placeholder="最低价"
              />
              <span>—</span>
              <input
                type="number"
                v-model="reqParameter.activity_price[1]"
                placeholder="最高价"
              />
            </div>
          </div>
          <div class="content">
            <div class="title">
              <h2>适用人群</h2>
              <!-- <img src="../../assets/yuncang/icon-02.png" alt="" /> -->
            </div>
            <van-row gutter="5">
              <van-col
                span="8"
                class="item"
                v-for="(item, index) in crowdList"
                :key="index"
                @click="checkcrowd(item.id)"
                ><p
                  :class="
                    reqParameter.sex.indexOf(item.id) != -1 ? 'current' : ''
                  "
                >
                  {{ item.label }}
                </p></van-col
              >
            </van-row>
          </div>
        </div>
        <!-- 操作按钮 -->
        <div class="btnsBox">
          <button class="reset" @click="reset()">重置</button>
          <button
            class="confirm"
            @click="
              show = false;
              onRefresh();
            "
          >
            确认
          </button>
        </div>
        <!-- 操作按钮 -->
      </div>

      <!-- 索引栏 -->
      <div v-if="!isVisible" class="IndexesBar">
        <van-nav-bar
          title="品牌"
          left-arrow
          @click-left="isVisible = true"
          right-text="确定"
          @click-right="confirm()"
        >
          <template #title>
            <van-search
              v-model="brandName"
              placeholder="请输入搜索关键词"
              @search="refreshBrandList()"
              @cancel="refreshBrandList()"
              @clear="refreshBrandList()"
            />
          </template>
        </van-nav-bar>
        <!-- <van-index-bar style="height: calc(100% - 44px); overflow-y: auto">
          <div>
            <van-index-anchor index="A"></van-index-anchor>
            <van-cell title="品牌名称" />
            <van-cell title="品牌名称" />
            <van-cell title="品牌名称" />
          </div>
        </van-index-bar> -->
        <div style="height: calc(100% - 44px); overflow-y: auto">
          <van-list
            v-model="brandLoading"
            :finished="brandFinished"
            finished-text="没有更多了"
            @load="onLoadBrand()"
          >
            <van-cell
              v-for="(item, index) in allBrand"
              :key="index"
              :class="brandArr.indexOf(item.id) != -1 ? 'checkingBrand' : ''"
              :title="(item.name ? item.name + '/' : '') + item.ename"
              :border="false"
              @click="clickBrand(item.id, item.ename)"
            />
          </van-list>
        </div>
      </div>
      <!-- 索引栏 -->
    </van-popup>
    <!-- 右侧弹出筛选条件 -->
    <!-- 商品列表 -->
    <div class="goodsList" :style="{ overflow: isResult ? 'hidden' : 'auto' }">
      <div class="noResult" v-if="isResult">
        <img src="../../assets/yuncang/noresult.png" alt="" />
        <p>没有找到相关商品</p>
        <span>请更换搜索词汇，或查看其他品类。</span>
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="listL">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="别拉了，小巴也是有底线的"
          @load="onLoad"
        >
          <van-row gutter="5">
            <van-col span="12">
              <div
                class="goodsItem"
                v-for="(item, index) in listL"
                @click="goDetailBS(item.id)"
                :key="index"
              >
                <div class="thumbBox" :style="goodsImgHeight">
                  <img class="thumb" :src="item.thumb" alt="" />
                </div>
                <h4>{{ item.name }}</h4>
                <div class="goodsMsg">
                  <strong><i>￥</i>{{ item.activity_min_price }}</strong>
                  <span>仅剩{{ item.inventory }}件</span>
                </div>
              </div>
            </van-col>
            <van-col span="12">
              <div
                class="goodsItem"
                v-for="(item, index) in listr"
                :key="index"
                @click="goDetailBS(item.id)"
              >
                <div class="thumbBox" :style="goodsImgHeight">
                  <img class="thumb" :src="item.thumb" alt="" />
                </div>
                <h4>{{ item.name }}</h4>
                <div class="goodsMsg">
                  <strong><i>￥</i>{{ item.activity_min_price }}</strong>
                  <span>仅剩{{ item.inventory }}件</span>
                </div>
              </div>
            </van-col>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 商品列表 -->
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      goodsImgHeight: {
        height: (document.body.clientWidth - 29) / 2 + "px",
      },
      show: false,
      isVisible: true,
      isiOSX: false,
      loading: false,
      finished: false,
      isLoading: false,
      brandLoading: false,
      brandFinished: false,
      isResult: false,
      brandPage: 0,
      more: false,
      listL: [],
      listr: [],
      allList: null,
      selectedBrand: [],
      allBrandName: [],
      reqParameter: {
        goods_type: 4,
        order_by: "inventory",
        sort: "desc",
        page: 0,
        pageSize: 10,
        name: "",
        third_category: null,
        brand_id: [],
        warehouse: [],
        sex: [],
        activity_price: [0],
      },
      orderByList: [
        { label: "综合", value: "inventory", icon: false },
        {
          label: "价格",
          value: "activity_min_price",
          icon: true,
        },
      ],
      //发货仓列表
      depositoryList: ["米兰仓", "国内仓", "杭州仓", "香港仓"],
      //使用人群列表
      crowdList: [
        { label: "男", id: 1 },
        { label: "女", id: 2 },
        { label: "儿童", id: 3 },
        { label: "中性", id: 5 },
        { label: "所有人群", id: 4 },
      ],
      brandList: [],
      allBrand: [],
      brandArr: [],
      brandName: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    goback() {
      this.$router.go(-1);
    },
    // 获取商品列表
    getGoodsList() {
      for (let key in this.reqParameter) {
        if (!this.reqParameter[key]) {
          delete this.reqParameter[key];
        }
      }
      this.$api
        .post("/ongoods/index/goods/search", this.reqParameter)
        .then((res) => {
          this.allList = res.total;
          if (Object.prototype.toString.call(res.list) == "[object Array]") {
            res.list.forEach((_, i) => {
              if (i % 2 == 0) {
                this.listL.push(_);
              } else {
                this.listr.push(_);
              }
            });
          }
          this.loading = false;
          if (this.listL.length + this.listr.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
          if (this.listL.length <= 0 && this.listr.length <= 0) {
            this.isResult = true;
          } else {
            this.isResult = false;
          }
        });
    },
    goDetailBS(id) {
      //商品详情
      let params = {
        goodsId: id,
        shopId: 4,
      };
      this.params(JSON.stringify(params), JSON.stringify(params), "goDetailBS");
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.reqParameter.page++;
        this.getGoodsList();
        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.reqParameter.page = 1;
      console.log(this.reqParameter.activity_price);
      if (!this.reqParameter.activity_price[0]) {
        this.reqParameter.activity_price[0] = 0;
      }
      if (!this.reqParameter.activity_price[1]) {
        this.reqParameter.activity_price.splice(1, 1);
      }
      this.finished = false;
      this.listL = [];
      this.listr = [];
      this.getGoodsList();
    },
    //点击筛选
    search(val) {
      if (val == "activity_min_price") {
        if (this.reqParameter.sort == "desc") {
          this.reqParameter.sort = "asc";
        } else {
          this.reqParameter.sort = "desc";
        }
      } else {
        this.reqParameter.sort = "desc";
      }
      this.reqParameter.order_by = val;
      this.onRefresh();
    },
    onClear() {
      this.reqParameter.name = "";
      this.onRefresh();
    },
    seeAllBrand() {
      this.brandArr = JSON.parse(JSON.stringify(this.reqParameter.brand_id));
      this.allBrandName = JSON.parse(JSON.stringify(this.selectedBrand));
      this.isVisible = false;
    },
    //获取品牌列表
    getBrandList() {
      this.$api
        .post("/ongoods/index/yc/brand-list", {
          name: "",
          page: 1,
          pageSize: 23,
        })
        .then((res) => {
          this.brandList = res.list;
        });
    },
    //选择品牌
    checkBrand(id, name) {
      let index = this.reqParameter.brand_id.indexOf(id);
      if (index < 0) {
        this.reqParameter.brand_id.push(id);
        this.selectedBrand.push(name);
      } else {
        this.reqParameter.brand_id.splice(index, 1);
        this.selectedBrand.splice(index, 1);
      }
    },
    //选择所有品牌中的品牌
    clickBrand(id, name) {
      let index = this.brandArr.indexOf(id);
      if (index < 0) {
        this.brandArr.push(id);
        this.allBrandName.push(name);
      } else {
        this.brandArr.splice(index, 1);
        this.allBrandName.splice(index, 1);
      }
    },
    confirm() {
      this.reqParameter.brand_id = this.brandArr;
      this.selectedBrand = this.allBrandName;
      this.isVisible = true;
    },
    //选择仓库
    checkDepository(item) {
      let index = this.reqParameter.warehouse.indexOf(item);
      if (index < 0) {
        this.reqParameter.warehouse.push(item);
      } else {
        this.reqParameter.warehouse.splice(index, 1);
      }
    },
    //选择人群
    checkcrowd(id) {
      let index = this.reqParameter.sex.indexOf(id);
      if (index < 0) {
        this.reqParameter.sex.push(id);
      } else {
        this.reqParameter.sex.splice(index, 1);
      }
    },
    //重置
    reset() {
      this.reqParameter.brand_id = [];
      this.reqParameter.warehouse = [];
      this.reqParameter.sex = [];
      this.reqParameter.activity_price = [0];
      this.selectedBrand = [];
      // this.onRefresh();
      // this.show = false;
    },
    //获取所有品牌
    getAllBrandList() {
      this.$api
        .post("/ongoods/index/yc/brand-list", {
          name: this.brandName,
          page: this.brandPage,
          pageSize: 20,
        })
        .then((res) => {
          this.allBrand = this.allBrand.concat(res.list);
          this.brandLoading = false;
          if (this.allBrand.length >= res.total) {
            // 数据全部加载完成
            this.brandFinished = true;
          }
        });
    },
    //更多品牌
    onLoadBrand() {
      setTimeout(() => {
        this.brandPage++;
        this.getAllBrandList();
      }, 500);
    },
    //刷新品牌列表
    refreshBrandList() {
      this.brandPage = 1;
      this.allBrand = [];
      this.brandFinished = false;
      this.getAllBrandList();
    },
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.reqParameter.third_category = this.$route.query.thirdCategory;
    this.reqParameter.name = this.$route.query.keyWord;
    if (this.$route.query.brandId) {
      this.reqParameter.brand_id.push(Number(this.$route.query.brandId));
      this.selectedBrand.push(this.$route.query.brandId);
    }

    this.getBrandList();
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.yuncang {
  background: #f5f6f7;
  height: 100%;
  box-sizing: border-box;
  .topNavBar {
    display: flex;
    flex-direction: row;
    padding: 5px 12px;
    align-items: center;
    .backIcon {
      margin-right: 10px;
      color: #000000;
      font-size: 18px;
      font-weight: bold;
    }
    .van-search {
      height: 34px;
      line-height: 34px;
      border-radius: 17px;
      padding: 0px 0px;
      width: 100%;
      .van-search__content {
        background-color: #ffffff;
        border-radius: 17px;
      }
    }
  }
  .factor {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 12px;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    line-height: 20px;
    .current {
      color: #f9591b;
    }
    .leftFactor {
      span:first-child {
        margin-right: 56px;
      }
      img {
        width: 8px;
        height: 12px;
      }
    }
    .rightFactor {
      position: relative;
      padding-right: 17px;
      img {
        position: absolute;
        width: 14px;
        height: 15px;
        right: 0;
        top: 2px;
      }
    }
  }
  .goodsList {
    padding: 0 12px;
    height: calc(100% - 84px);
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    overflow-y: scroll;
    .noResult {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      img {
        width: 280px;
      }
      p {
        font-size: 13px;
        font-weight: 400;
        color: #333333;
        line-height: 9px;
        margin-top: 39.5px;
        margin-bottom: 14.5px;
      }
      span {
        font-size: 11px;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
      }
    }
    .goodsItem {
      background: #ffffff;
      border-radius: 6px;
      padding-bottom: 10px;
      margin-bottom: 5px;
      overflow: hidden;
      .thumbBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .thumb {
        max-width: 100%;
        max-height: 100%;
      }
      h4 {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        padding: 0 10px;
        margin: 10px 0;
        height: 44px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .goodsMsg {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 0 10px;
        line-height: 18px;
        strong {
          font-weight: 500;
          color: #f41a3c;
          font-size: 18px;
          i {
            font-size: 14px;
            font-style: normal;
          }
        }
        span {
          font-size: 11px;
          font-weight: 400;
          color: #999999;
          line-height: 16px;
        }
      }
    }
  }
  .van-popup {
    .btnsBox {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 78px;
      width: 100%;
      padding: 4px 12px 0;
      box-sizing: border-box;
      text-align: right;
      background: #ffffff;
      .reset {
        height: 36px;
        width: 87px;
        border: none;
        background: #feebe3;
        border-radius: 18px 0px 0px 18px;
        font-size: 16px;
        font-weight: 400;
        color: #f9591b;
      }
      .confirm {
        height: 36px;
        width: 87px;
        border: none;
        background-image: linear-gradient(
          92deg,
          #fa2c2c 0%,
          #ff6e40 100%,
          #ff4e30 100%
        );
        border-radius: 0px 18px 18px 0px;
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }

  .typeMain {
    padding: 54px 12px 0;
    height: calc(100% - 78px);
    box-sizing: border-box;
    overflow-y: auto;
    .content {
      margin-bottom: 15px;
      .brandUl {
        overflow: hidden;
      }
      .title {
        display: flex;
        justify-content: space-between;
        .selectBrand {
          width: 210px;
          p {
            width: 190px;
            display: inline-block;
            text-align: right;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            color: #f9591b;
            span {
              font-size: 13px;
              font-weight: 400;
              color: #f9591b;
              line-height: 18px;
            }
          }
        }
        h2 {
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          margin: 0;
        }
        img {
          width: 20px;
          height: 20px;
        }
      }
      .item {
        margin-top: 10px;
        p {
          line-height: 33px;
          height: 33px;
          background: #ededed;
          border-radius: 3px;
          text-align: center;
          font-weight: 400;
          color: #666666;
          font-size: 14px;
          border: 1px solid #ededed;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        p.current {
          background: #feebe3;
          border-radius: 3px;
          border: 1px solid #fa2c2c;
          color: #f9591b;
        }
        p.moreBtn {
          background: none;
          border-radius: 3px;
          border: 1px solid #979797;
        }
      }
      .priceRange {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        input {
          width: 120px;
          height: 35px;
          background: #ededed;
          border-radius: 18px;
          padding: 0px;
          text-align: center;
          border: none;
          font-size: 14px;
        }
      }
    }
  }
}
.checkingBrand {
  color: #f9591b;
}
</style>
<style lang="less">
.yuncang {
  .topNavBar {
    .van-icon-search::before {
      content: "";
      width: 19px;
      height: 19px;
      background: url("../../assets/yuncang/icon-07.png") no-repeat;
      background-size: 100%;
    }
    .van-field__left-icon {
      margin-right: 7px;
    }
    .van-field__control::-webkit-input-placeholder {
      color: #999999;
    }
    .van-field__control::-moz-placeholder {
      color: #999999;
    }
    .van-field__control::-moz-placeholder {
      color: #999999;
    }
    .van-field__control::-ms-input-placeholder {
      color: #999999;
    }
  }
  .van-nav-bar {
    background: none;
    height: 44px;
    .van-nav-bar__left {
      .van-icon {
        color: #000;
        font-size: 18px;
        font-weight: bold;
      }
    }
    .van-nav-bar__title {
      font-size: 18px;
      color: #333333;
      font-weight: 600;
    }
  }
  [class*="van-hairline"]::after {
    border-bottom: none;
  }
  .IndexesBar {
    height: 100%;
    padding-top: 54px;
    box-sizing: border-box;
    .van-nav-bar__text {
      background: linear-gradient(to right, #fa2c2c, #ff6e40, #ff4e30);
      -webkit-background-clip: text;
      color: transparent;
      -webkit-text-fill-color: transparent;
      text-fill-color: transparent;
      font-size: 14px;
    }
    .van-index-bar__sidebar {
      padding-right: 12px;
    }
    .van-index-anchor--sticky {
      left: 0 !important;
      //   background-color: transparent !important;
    }
    .van-cell::after {
      border-bottom: none;
    }
    .van-index-bar__index--active {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #d8d8d8;
      color: #333333;
    }
    .van-index-bar__index {
      padding: 0;
      line-height: 16px;
      font-size: 12px;
      margin-bottom: 2px;
    }
    .van-search {
      height: 34px;
      line-height: 34px;
      border-radius: 17px;
      padding: 0px 0px;
      width: 100%;
      .van-search__content {
        background-color: #f2f2f2;
        border-radius: 17px;
      }
      .van-icon-search::before {
        content: "";
        width: 19px;
        height: 19px;
        background: url("../../assets/yuncang/icon-07.png") no-repeat;
        background-size: 100%;
      }
      .van-field__left-icon {
        margin-right: 7px;
      }
      .van-field__control {
        font-weight: normal;
      }
      .van-field__clear {
        color: #999999;
      }
      .van-field__control::-webkit-input-placeholder {
        color: #999999;
      }
      .van-field__control::-moz-placeholder {
        color: #999999;
      }
      .van-field__control::-moz-placeholder {
        color: #999999;
      }
      .van-field__control::-ms-input-placeholder {
        color: #999999;
      }
    }
  }
}
</style>